// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1mPZs","footer":"ModalCreateQualiphyProcedure_footer__3vOUc","additionData":"ModalCreateQualiphyProcedure_additionData__2vxqy"};